import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../../components/Button/Button";
import GenericHeader from "../../components/GenericHeader/GenericHeader";
import Popup from "../../components/PopUp/PopUp";
import BasicDetails from "./BasicDetails";
import ProposalDetails from "./ProposalDetails";
import CompanyInformation from "./CompanyInformation";
import "./ApplyBrief.css"; // Import the CSS file
import { details } from "./ApplyBriefUtils";
import {
  fetch_Brief_Proposals,
  getAllCurrencyName,
  submitProposal,
} from "../../services/applyBriefAPI";
import { mapResponseToFormFields, postData } from "../EditProposals/SolictedProposalHook";
import { updateProposal } from "../../services/api";
import FileUploader from "../../components/FileUploader/FileUploader";
import ProgressLoader from "../../components/ProgressLoader/ProgressLoader";
import { useSelector } from "react-redux";
import { useLanguage } from '../../context/Languagecontext';
import FallBackLabel from '../../global/Globals_Eng.json';

const ApplyBrief = (props) => {
  const { Globals ,languages, setLanguages } = useLanguage();
  const navigate=useNavigate();
  const doesFormHaveValues = useSelector(state => state.applyBrief.isProposalDetailsPartiallyFilled);
  const [popupState, setPopupState] = useState(null);
  const [isValidated, setValidated] = useState(true); // default to false
  const [isExpanded, setIsExpanded] = useState(true);
  const [currencyName, setCurrencyName] = useState([]);
  const [submitTrigger, setSubmitTrigger] = useState(false);
  const [Form, setForm] = useState([]);
  const [data, setData] = useState({});
  const [formValues, setFormValues] = useState([]);
  const location = useLocation();
  const { activeData } = location.state || {};
  const [isRegFailed, setRegFailure] = useState(false);
  const [retryStatus, setretryStatus] = useState();
  const [loading,setLoading] =useState(false)
  const proposalId = activeData[0];
  const formRef = useRef(null);  // Create a ref for the form
const [files,setFiles]=useState({lookBoardMoodBaord1:'',productionSchedule1:'',reel:'',cer:'',reg:''})
  const handleFormDataChange = (value1) => {
    const newFormData = { ...formValues };

    // Iterate through the keys of the keyObj and set the values
    for (const [key, value] of Object.entries(value1)) {
      newFormData[key] = value;
    }
  
    setFormValues(newFormData);
  };

  const fileUpload = (key, value) => {
    setFiles((prev) => ({
      ...prev, // Spread the previous state to retain existing properties
      [key]: value, // Add or update the key with the new value
    }));
  };

  const handleBack = async () => {
    retryStatus ==='' && setretryStatus(popupState)
    if(popupState==="cross" || retryStatus === "cross" ){
      setRegFailure(false);
      navigate(Globals.NAVPATH.HOME, { state: { activeHeader: "dashboard",success:true,draft:false, discard:true } })
    }
    else if (popupState==="brief" || retryStatus === "brief" ) {
     
      // setSubmitTrigger(true);
      try {
        setLoading(true)
        const response = await submitProposal(postData(proposalId, formValues, 0,undefined,files));
        setLoading(false)
        if(response.data.status!=="OK"){
          setRegFailure(true);
        }
            else if (response.data.content) {
              const success=response?.data?.content
              navigate(Globals.NAVPATH.HOME, { state: { activeHeader: "proposals",success,user: "producer"}})
             resetSates();
            }
            else {
                setRegFailure(true);
            }
      } catch (error) {
        setLoading(false)
        setRegFailure(true);
        console.error("Error in fetching brief info", error);
      }
    } else if (popupState==="draft" || retryStatus === "draft") {
      try {
        setLoading(true)
        const response = await submitProposal(postData(proposalId, formValues,1,undefined,files ));
        setLoading(false)
        if(response.data.status!=="OK"){
          setRegFailure(true);
        }
            else if (response.data.content) {
              const success = response?.data?.content
          navigate(Globals.NAVPATH.HOME, { state: { activeHeader: "proposals", success, draft: true,user: "producer" } })
              setRegFailure(false);
              resetSates();
            }
            else {
                setRegFailure(true);
            }
      } catch (error) {
        setRegFailure(true);
        setLoading(false)  
        console.error("Error in fetching brief info", error);
      } 
    }
   
  };

  const handleTextArea = (type, message) => {};
  const handleButtonClick = (type) => {
    setretryStatus('')
    setPopupState('')
    console.log("Form Data:", formValues);
    if(type==='brief'){
      setSubmitTrigger(!submitTrigger);
      isValidated && setPopupState(type);
    }
    else if (type === 'draft') {
      setPopupState(type);
    }
     else {
      // setSubmitTrigger(true);
      setPopupState(type);
    }
  };

  const getBriefByProposalId = async (proposalId) => {
    try {
      const response = await fetch_Brief_Proposals(proposalId);
      console.log("getBriefByProposalId===", response);
    } catch (error) {
      console.error("Error in fetching brief info", error);
    }
  };

  const getCurrencyName = async () => {
    try {
      const response = await getAllCurrencyName();
      const currencyNames = response.data.content.Currencies.map(
        (item) => item.name
      );
      setCurrencyName(currencyNames);
      setData(response.data.content)
    } catch (error) {
      console.error("Error in fetching brief info", error);
    }
  };

  useEffect(() => {
    setForm(mapResponseToFormFields({"productionTypeName":activeData?.[0]?.productionTypeName},Globals));
    setFormValues(postData());
    getCurrencyName();
  }, []);

  function validateFormFields(formFields) {
    let isValid = true;
    let isEpisodevalid=(activeData?.[0]?.formatType  === "M" || activeData?.[0]?.formatType  === "E") ?'':'episodeStructure'
    let keysToOmit = ['updatedBy','status','createdBy','proposalDetailId','reel','proposalId','propRefNo','locationStudioInfo','lookBoardMoodBaord1','productionSchedule','lookBoardMoodBaord','castPresenterInfo','showReel','certCopyRightRegistration','regulatoryDocument','cer','reg',isEpisodevalid];
    if (activeData?.[0]?.productionTypeName !== Globals.ADVERTISER_PROGRAMME) {
      keysToOmit.push('brandIntegration');
    }
    if (activeData?.[0]?.productionTypeName && (activeData?.[0]?.productionTypeName === Globals.ADVERTISER_PROGRAMME)) {
      keysToOmit = keysToOmit.filter(key => key !== 'brandIntegration');
    }
    if (Array.isArray(formFields)) {
        formFields.forEach(field => {
            for (const [key, value] of Object.entries(field)) {
                if (!value || value === "00000000-0000-0000-0000-000000000000") {
                    isValid = false;
                    break;
                }
            }
        });
    } else if (typeof formFields === 'object') {
        for (const [key, value] of Object.entries(formFields)) {
          if (keysToOmit.includes(key)) {
            continue;
          }
          if ((key === "productionSchedule1" || key === "lookBoardMoodBaord1") && value === null) {
            isValid = false;
            break;
          }
            if (value=='') {
                isValid = false;
                break;
            }
        }
    } else {
        isValid = false;
    }
    return isValid;
  } 
  
  useEffect(() => {
    const requiredFields = [
      "Preliminary_Budget",
      "Proposal_Title",
      "Synopsis",
      "Logline",
      "Editorial_Details",
      "Episode_Structure_and_Outline",
      "Location_and_Studio_Information",
      "Company_Profile_and_Team_Details",
      "Brand_Integration_Opportunities",
      "Cast_and_Presenter_Information",
    ];
// const isFormValid=true;
    const isFormValid = validateFormFields(formValues) && validateFormFields(files);
    isFormValid ? setValidated(true):setValidated(false);
  }, [formValues,files,activeData?.[0]?.productionTypeName]);

  const showPopup = (title, message, button1, button2 = null) => {
    if(popupState==="cross"){
      return (
        <Popup
        title={title}
        text={message}
        negativeAction={handleBack}
        negativeActionText={button1}
        // popupType={"abort"}
        onClose={() => {
          setRegFailure(false)
          setPopupState('')
         }}
        buttonBGColor={popupState !== "cross" ? "#004894" : ""}
      />
      
      );
    }
    else{
      return (
        <Popup  onClose={() => {
          setRegFailure(false)
          setPopupState('')
         }}
                    text={message || ''}
                    title={title || ''}
                normalAction={handleBack}
                    negativeActionText={button1}
                    normalActionText={popupState === "draft"?Globals.SAVE_AS_DRAFT:Globals.SUBMIT_PROPOSAL}
                />
      );
    }
  };

  const resetSates = () => {
    // setPopupState("");
    setRegFailure(false)
  };

  const handleSubmit = () => {
    setSubmitTrigger(!submitTrigger);
    if (!isValidated) {
      // formRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const buttonUI = () => {
    return (
      <div>
        {/* Buttons */}
        <div className="apply-brief-button-group-container">
          <div className="apply-brief-button-group">
            <button
              className="apply-brief-cancel-btn"
              onClick={() => handleButtonClick("cross")}
            >
              {Globals.CREATE_NEW_BRIEF.CANCEL_BUTTON}
            </button>
            <button
              // className=""
              onClick={() => handleButtonClick("draft")}
              className={`${(doesFormHaveValues || formValues["regulatoryDocument"] || formValues["certCopyRightRegistration"]) ? "apply-brief-draft-btn"
                : "apply-brief-draft-btn-disabled"}`}
              disabled={!doesFormHaveValues && formValues["regulatoryDocument"] === undefined && formValues["certCopyRightRegistration"] === undefined}
            >
              {Globals.CREATE_NEW_BRIEF.SAVE_AS_DRAFT}
            </button>
            <Button
              title={Globals.SUBMIT_PROPOSAL}
              additionalStyle={
                isValidated
                  ? "apply-brief-create-btn"
                  : "apply-brief-create-btn-disabled"
              }
            //  action={handleSubmit}
              id="Create-Brief-Button"
              action={() => {
                handleButtonClick("brief");
              }}
              disable={!isValidated} // Disable button when not validated
            />
          </div>
        </div>
        {popupState &&
          showPopup(
            Globals.APPLY_BRIEF.POPUP[popupState].TITLE,
            `${Globals.APPLY_BRIEF.POPUP[popupState].MESSAGE}${popupState === "brief" ? ` "${formValues?.projectTitle}" ${Globals.TO.toLowerCase()} ${activeData[0]?.channelName}?`: ''}`,
            Globals.APPLY_BRIEF.POPUP[popupState].BUTTON_TEXT
          )}
          {isRegFailed &&
         <div className='popup-bg'><Popup title={((popupState||retryStatus) === Globals.DRAFT)?Globals.SOLICITED_FAILED_SAVE_POPUP_TITLE:Globals.SOLICITED_FAILED_POPUP_TITLE}
         text={Globals.UNSOLICITED_FAILED_POPUP_MESSAGE}
         normalAction={()=>{handleBack()}}
         normalActionText={Globals.SIGNUP.POPUP.FAILURE.BUTTON_TEXT}
         popupType={"failed"}
         onClose={() => {
          setRegFailure(false)
          setPopupState('')
         }
          }
     /></div>}
      </div>
    );
  };
  const handleShowReelFile =(file)=>{
    const newFormData = { ...formValues };
    newFormData["showReel"] = file;
    setFormValues(newFormData);
    fileUpload("reel",file)
  }
  const handleCertificatePdfFile=(file)=>{
    const newFormData = { ...formValues };
    newFormData["certCopyRightRegistration"] = file;
    setFormValues(newFormData);
    fileUpload("cer",file)
  }
  const handleRegulatoryDocPdfFile=(file)=>{
    const newFormData = { ...formValues };
    newFormData["regulatoryDocument"] = file;
    setFormValues(newFormData);
    fileUpload("reg",file)
  }
  const handleFileRemoveShowReelFile =()=>{
    const newFormData = { ...formValues };
    newFormData["showReel"] = undefined;
    setFormValues(newFormData);
    fileUpload("reel",'')
    
  }
  const handleFileRemoveCertificatePdfFile=()=>{
    const newFormData = { ...formValues };
    newFormData["certCopyRightRegistration"] = undefined;
    setFormValues(newFormData);
    fileUpload("cer",'')
  }
  const handleFileRemoveRegulatoryDocPdfFile=()=>{
    const newFormData = { ...formValues };
    newFormData["regulatoryDocument"] = undefined;
    fileUpload("reg",'')
    setFormValues(newFormData);
  }
  return (
    <>
    <div className="apply-brief-container">
      
      {/* Basic details */}
      <GenericHeader
        title={Globals.APPLY_BRIEF.TITLE}
        onClose={() => handleButtonClick("cross")}
      />
      <BasicDetails
        setIsExpanded={setIsExpanded}
        isExpanded={isExpanded}
        data1={activeData}
      />
      {/* Proposal details */}
      <ProposalDetails
        handleTextArea={handleTextArea}
        onFormDataChange={handleFormDataChange}
        submitTrigger={submitTrigger}
        currentList={currencyName}
        details={Form}
        formValues={formValues}
        currencyData={data}
        episodeShow={(activeData?.[0]?.formatType  === "M" || activeData?.[0]?.formatType  === "E" )}
        fileUpload={fileUpload}
        productionType={activeData?.[0]?.productionTypeName}
      />
      {/* Company Information */}
      <div className="apply-brief-company-info-container">
      <label className="brief-basic-details-text">
        {Globals.APPLY_BRIEF.COMPANY_INFORMATION}
      </label>
      <div className="brief-apply3-container">
        {/* Showreel Upload */}
        <div className="brief-apply3-card">
          <label className="brief-apply3-title">
            {Globals.APPLY_BRIEF.SHOW_REEL}
  {/* <span className="required"> *</span> */}
          </label>
          <FileUploader
            supportedFileType="VideosOnly"
            onFileUpload={(file)=>handleShowReelFile(file)}
            className="brief-apply3-file-wrapper"
            onFileRemove={handleFileRemoveShowReelFile}
          />
        </div>

        {/* Certificate Upload */}
        <div className="brief-apply3-card">
          <label className="brief-apply3-title">
            {Globals.APPLY_BRIEF.CERTIFICATE}
            {/* <span className="required"> *</span> */}
          </label>
          <FileUploader
            supportedFileType="pdfOrDocOnly" 
            onFileUpload={(file)=>handleCertificatePdfFile(file)}
            className="brief-apply3-file-wrapper"
            onFileRemove={handleFileRemoveCertificatePdfFile}
          />
        </div>

        {/* Regulatory Documentation Upload */}
        <div className="brief-apply3-card">
          <label className="brief-apply3-title">
            {Globals.APPLY_BRIEF.REGULAROTY}
            {/* <span className="required"> *</span> */}
          </label>
          <FileUploader
            supportedFileType="pdfOrDocOnly" 
            onFileUpload={(file)=>handleRegulatoryDocPdfFile(file)}
            className="brief-apply3-file-wrapper"
            onFileRemove={handleFileRemoveRegulatoryDocPdfFile}
          />
        </div>
      </div>
    </div>
      {buttonUI()} 
      
    </div>
    {loading && <ProgressLoader width={50} height={50} component={"create-solicated"}/>}
    </>
  );
};

export default ApplyBrief;
